import { Component, OnInit } from '@angular/core';
import { BusService } from 'app/services/bus.service';
import { EventsService } from 'app/services/events.service';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Params } from '@angular/router';
import { RecordsResourceService, RecordsModel } from 'app/services/records/record-resource.service';
import { DsarCreateDialogComponent } from '../create-dialog/create-dialog.component';
import { getRefNum } from '../../util';
import { AccessControlService } from '../../../../services/access-control.service';


@Component({
  selector: 'app-dsar-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DsarDetailsComponent implements OnInit {
  record: RecordsModel;
  id: number;
  documents = [];
  redacted = false;

  roleSelection = null;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private access: AccessControlService,
    private recordsService: RecordsResourceService // Needs to be here to catch direct URL visits
  ) { }

  get hasTitle() {
    return this.record.title && this.record.title.length > 0;
  }

  get isDstOrHigher() {
    return this.access.hasRoleOrStronger('org_roles.dst');
  }

  getRefNumber(record: RecordsModel) {
    if (record) {
      return getRefNum(record);
    }
  }

  edit() {
    this.dialog.open(DsarCreateDialogComponent, {
      width: '700px',
      data: this.record
    }).afterClosed().subscribe(mutated => {
      if (mutated) {
        this.requestRefresh();
      }
    });
  }

  requestRefresh() {
    this.bus.publish(this.events.requested.data.records.single, this.record);
  }

  handleError(error: any) {
    if (error && error.status === 403) {
      this.redacted = true;
      this.record = { id: this.id, type: 'dsar', title: 'Redacted', prefix: 'BA-' };
    }
  }

  ngOnInit() {
    this.subscribe();

    if (this.access.hasRoleOrStronger('org_roles.dst')) {
      this.roleSelection = { role: 'org_roles.dsbv' };
    }
  }

  subscribe() {
    this.bus.subscribe(this.events.received.data.records.single.success, this.receiveRecord.bind(this));
    this.bus.subscribe(this.events.received.data.records.single.failure, this.handleError.bind(this));

    this.activatedRoute.params.subscribe((params: Params) => {
      const model = { id: params.id, type: 'dsar' };
      this.id = params.id; // Masks console error while loading and passing to ViewChildren
      this.bus.publish(this.events.requested.data.records.single, model);
    });
  }

  /* DOCUMENTS */

  // each record has its own custom upload URL which handles associations
  get uploadUrl() {
    if (this.record) {
      return '/records/dsar/' + this.record.id + '/file';
    }
  }

  private receiveRecord(record: RecordsModel) {
    this.record = record;
    this.documents = record.documents;
  }
}
